(function () {
    'use strict';

    angular
        .module('elogbooks.admin.site-associations')
        .factory('siteAssociateStateService', siteAssociateStateService);

    function siteAssociateStateService() {
        // Store the IDs of removed associate types
        let removedAssociateTypeIds = [];

        return {
            addRemovedAssociateType: addRemovedAssociateType,
            removeRemovedAssociateType: removeRemovedAssociateType,
            isAssociateTypeRemoved: isAssociateTypeRemoved,
            getRemovedAssociateTypeIds: getRemovedAssociateTypeIds,
            clearRemovedAssociateTypes: clearRemovedAssociateTypes
        };

        function addRemovedAssociateType(id) {
            if (removedAssociateTypeIds.indexOf(id) === -1) {
                removedAssociateTypeIds.push(id);
            }
        }

        function isAssociateTypeRemoved(id) {
            return removedAssociateTypeIds.indexOf(id) !== -1;
        }

        function getRemovedAssociateTypeIds() {
            return removedAssociateTypeIds;
        }

        function removeRemovedAssociateType(id) {
            var index = removedAssociateTypeIds.indexOf(id);
            if (index !== -1) {
                removedAssociateTypeIds.splice(index, 1);
            }
        }

        function clearRemovedAssociateTypes() {
            removedAssociateTypeIds = [];
        }
    }
})();
